import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

export enum PrCardType {
  TEXT,
  EURO,
  HTML,
  PERCENT,
  PERCENT_WITH_2_DECIMAL,
  RISK_LEVEL_LADDER,
  SCORING,
}

export interface PrCardIcon {
  name: string;
  width?: number;
  height?: number;
  viewBoxWidth?: number;
  viewBoxHeight?: number;
}

export class PrCard {
  icon: PrCardIcon;
  label: string;
  value: any;
  type: PrCardType;
  tooltip: string;
  display: string;
  fill: boolean;
  options: boolean;
  sublabel?: any;
  subvalue?: any;

  constructor(
    icon: string | PrCardIcon,
    label: string,
    type: PrCardType,
    value: any,
    tooltip?: string,
    display: string = 'neutral',
    fill: boolean = false,
    sublabel?: any,
    subvalue?: any,
  ) {
    this.icon = typeof icon == 'object' ? icon : { name: icon };
    this.label = label;
    this.type = type;
    this.value = value;
    if (tooltip) this.tooltip = tooltip;
    if (display == null) display = 'neutral';
    else this.display = display;
    this.fill = fill;
    this.sublabel = sublabel;
    this.subvalue = subvalue;
  }
}

/**
 * @var icon
 * reference https://fontawesome.com/v4.7/icons/
 *
 * Les variables sont projetés avec <ng-content> pour permettre d'utiliser les pipes/directives
 * Conseil d'utilisation simple :
 * @var value <em value>Valeur</em>
 * @var title <em title>Titre</em>
 */

@Component({
    selector: 'pr-card',
    templateUrl: './pr-card.component.html',
    styleUrls: ['./pr-card.component.scss'],
    standalone: false
})
export class PrCardComponent implements OnInit {
  @Input() icon: PrCardIcon;
  @Input() label: string;
  @Input() value: any;
  @Input() type: PrCardType;
  @Input() tooltip: string;
  @Input() display: string;
  @Input() loading: boolean = false;
  @Input() sublabel: any;
  @Input() subvalue: any;
  _ = _;
  Math = Math;

  @Input() set card(card: PrCard) {
    this.icon = card.icon;
    this.label = card.label;
    this.type = card.type;
    this.tooltip = card.tooltip;
    this.display = card.display;
    this.sublabel = card.sublabel;
    this.subvalue = card.subvalue;
    // Handle value as an observable or as a simple value
    if (
      card.value &&
      !Array.isArray(card.value) &&
      typeof card.value == 'object'
    )
      card.value.subscribe(value => (this.value = value));
    else this.value = card.value;
  }

  PrCardType = PrCardType;

  constructor() {}

  ngOnInit() {}
}
